import { useEffect } from "react";

import { useForm } from "react-final-form";

import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import FormRow from "components/form/FormRow";

import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";

import Perf from "..";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Operador from "entity/Operador";

export default function PerfEditFields({ visita, TipoClass }) {
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(Perf, tipo, TipoClass);

    const [apontamento] = useFieldValue();

    const form = useForm();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = Perf.calcConformidade(apontamento, params);
            form.change("coletas", apontamento.coletas);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields
                visita={visita}
                TipoClass={TipoClass}
                showTrator={false}
                showImplemento={false}
                showFrente={false}
                showVariedade
            />

            <ApontamentoAmostraParams showTipo={false}>
                <FormRow>
                    <TextInput name="insumo" label="Variedade" />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Metros Avaliados: ">{params.metrosAvaliados}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="perfilhos" label="Número de Perfilhos" />
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Perfilhos por Metro"></ApontamentoResultado>
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
